import type { ChainStyleApplyResult } from '../types/chain-style-apply-result'

export const NOT_HANDLED_CHAIN_STYLE: ChainStyleApplyResult = {
  handled: false,
  claimedShapeIds: new Set<string>(),
}
